/**
 * The landing page about each channel an agent answers on, keyed by the brand
 * key `resolveChannelIcon` draws the channel with. Channel chips on /chatbots
 * and the industry pages link here; a channel without a page of its own
 * (website chat, shareable link, Zapier) stays plain text.
 */
export const CHANNEL_PAGES: Record<string, string> = {
  FaWhatsapp: '/chatbots/whatsapp',
  FaFacebookMessenger: '/chatbots/messenger',
  FaTelegram: '/chatbots/telegram',
  FaLine: '/chatbots/line',
  FaSlack: '/chatbots/slack',
  Gmail: '/chatbots/email',
  Outlook: '/chatbots/email',
  FaEnvelope: '/chatbots/email',
  FaShopify: '/chatbots/shopify',
  FaWordpress: '/chatbots/wordpress',
  FaPhone: '/ai-receptionist',
};
